import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UserModal from "./modules/UserModal";
import PasswordModal from "./modules/PasswordModal";
import { getAction } from '@/api/manage';
import { frozenBatch } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import SysUserAgentModal from "./modules/SysUserAgentModal";
import { unbindWechat } from "@/api/login";
export default {
  name: 'UserList',
  mixins: [JeecgListMixin],
  components: {
    SysUserAgentModal: SysUserAgentModal,
    UserModal: UserModal,
    PasswordModal: PasswordModal
  },
  data: function data() {
    return {
      description: '这是用户管理页面',
      queryParam: {},
      tenantList: [],
      color: ['pink', 'red', 'orange', 'cyan', 'green', 'purple', 'blue'],
      columns: [
      /*{
                    title: '#',
                    dataIndex: '',
                    key:'rowIndex',
                    width:60,
                    align:"center",
                    customRender:function (t,r,index) {
                      return parseInt(index)+1;
                    }
                  },*/
      {
        title: '用户账号',
        align: 'center',
        dataIndex: 'username',
        width: 120
      }, {
        title: '真实姓名',
        align: 'center',
        width: 100,
        dataIndex: 'realname',
        scopedSlots: {
          customRender: 'realnameslot'
        }
      }, {
        title: '头像',
        align: 'center',
        width: 120,
        dataIndex: 'avatar',
        scopedSlots: {
          customRender: 'avatarslot'
        }
      }, {
        title: '角色',
        align: 'center',
        width: 80,
        dataIndex: 'roleList',
        scopedSlots: {
          customRender: 'roleListslot'
        }
      }, {
        title: '岗位',
        align: 'center',
        width: 80,
        dataIndex: 'postName',
        sorter: true
      }, // {
      //     title: '生日',
      //     align: "center",
      //     width: 180,
      //     dataIndex: 'birthday'
      // },
      {
        title: '部门',
        align: 'center',
        width: 170,
        dataIndex: 'depart'
      }, {
        title: '租户名称',
        align: 'center',
        dataIndex: 'tenantName',
        width: 150
      }, {
        title: '状态',
        align: 'center',
        width: 80,
        dataIndex: 'status_dictText'
      },
      /* {
                     title: '创建时间',
                     align: "center",
                     width: 150,
                     dataIndex: 'createTime',
                     sorter: true
                   },*/
      {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 170
      }],
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
        syncUser: '/process/extActProcess/doSyncUser',
        list: '/sys/user/list',
        delete: '/sys/user/delete',
        deleteBatch: '/sys/user/deleteBatch',
        exportXlsUrl: '/sys/user/exportXls',
        importExcelUrl: 'sys/user/importExcel',
        resetPassword: 'sys/user/resetPassword',
        queryAllTenant: '/sys/tenant/queryAllTenant'
      }
    };
  },
  created: function created() {
    this.loadAllTenant(); // let test = JSON.stringify(this.record.roleList)

    console.log('test', this.record.roleList);
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadAllTenant: function loadAllTenant() {
      var that = this;
      that.tenantList = [];
      getAction(that.url.queryAllTenant).then(function (res) {
        if (res.success) {
          that.tenantList = res.result;
        }
      });
    },
    loadData: function loadData(arg) {
      this.queryParam.delFlag = 0;
      this.initTableData(arg);
    },
    getAvatarView: function getAvatarView(avatar) {
      console.log('avatar', this.url.imgerver + '/' + avatar);
      return this.url.imgerver + '/' + avatar;
    },
    // getRoleName: function (avatar) {
    //   return this.url.imgerver + '/' + avatar
    // },
    batchFrozen: function batchFrozen(status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return false;
      } else {
        var ids = '';
        var that = this;
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ',';
        });
        that.$confirm({
          title: '确认操作',
          content: '是否' + (status == 1 ? '解冻' : '冻结') + '选中账号?',
          onOk: function onOk() {
            frozenBatch({
              ids: ids,
              status: status
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleMenuClick: function handleMenuClick(e) {
      if (e.key == 1) {
        this.batchDel();
      } else if (e.key == 2) {
        this.batchFrozen(2);
      } else if (e.key == 3) {
        this.batchFrozen(1);
      } else if (e.key == 4) {
        this.resetPassword();
      }
    },
    handleFrozen: function handleFrozen(id, status) {
      var that = this;
      frozenBatch({
        ids: id,
        status: status
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handleUnBind: function handleUnBind(userId) {
      var _this = this;

      unbindWechat({
        userId: userId
      }).then(function (res) {
        if (res.success) {
          _this.loadData();

          _this.$notification.success({
            message: '解绑成功!'
          });
        }
      });
    },
    handleChangePassword: function handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    handleAgentSettings: function handleAgentSettings(username) {
      this.$refs.sysUserAgentModal.agentSettings(username);
      this.$refs.sysUserAgentModal.title = '用户代理人设置';
    },
    passwordModalOk: function passwordModalOk() {//TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    },
    resetPassword: function resetPassword() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return false;
      } else {
        var ids = '';
        var that = this;
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ',';
        });
        getAction(this.url.resetPassword, {
          ids: ids
        }).then(function (res) {
          if (res) {
            that.$notification.success({
              message: '修改成功!'
            });
            that.loadData();
          } else {
            that.$notification.warning({
              message: '修改失败!'
            });
          }
        });
      }
    },
    modalFormOk: function modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    handleAdd: function handleAdd() {
      var _this2 = this;

      var tenantId = window.localStorage.getItem('tenant'); // 1用户 2站点

      getAction("/sys/tenant/superiorLimit/" + Number(tenantId) + "/" + 1).then(function (res) {
        if (res.success) {
          if (res.result > 0 || res.result == null) {
            _this2.$refs.modalForm.add();

            _this2.$refs.modalForm.title = '新增：' + _this2.pageTitle;
            _this2.$refs.modalForm.disableSubmit = false;
            _this2.$refs.modalForm.showTab = false;
            _this2.$refs.modalForm.showContact = false;

            if (res.result > 0) {
              _this2.$notification.success({
                message: "该租户还可以添加" + res.result + "个用户！"
              });
            }
          } else {
            _this2.$notification.warn({
              message: "该租户下的用户数量已达到上限，不可再继续添加，请联系管理员！"
            });
          }
        }
      });
    }
  }
};